import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../App';
import { Home, Briefcase, Plus, Settings } from 'lucide-react';

const BottomNav = () => {
  const { user } = useAuth();
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + '/');

  // Build nav items based on user permissions
  const navItems = [
    { path: '/dashboard', label: 'Home', icon: Home },
    { path: '/jobs-list', label: 'Jobs', icon: Briefcase },
  ];

  if (user?.can_post_jobs || user?.is_admin) {
    navItems.push({ path: '/jobs?create=true', label: 'Post Job', icon: Plus, isAction: true });
  }

  if (user?.is_admin) {
    navItems.push({ path: '/admin', label: 'Admin', icon: Settings });
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40 safe-area-inset-bottom">
      <div className="flex items-center justify-around h-16 max-w-7xl mx-auto px-4">
        {navItems.map(({ path, label, icon: Icon, isAction }) => {
          const basePath = path.split('?')[0];
          const active = isActive(basePath);

          if (isAction) {
            return (
              <Link
                key={path}
                to={path}
                className="flex flex-col items-center justify-center flex-1 py-2"
              >
                <div className="bg-amber-600 rounded-full p-3 -mt-5 shadow-lg hover:bg-amber-700 transition-colors">
                  <Icon className="h-5 w-5 text-white" />
                </div>
                <span className="text-xs mt-2 text-amber-600 font-medium">{label}</span>
              </Link>
            );
          }

          return (
            <Link
              key={path}
              to={path}
              className={`flex flex-col items-center justify-center flex-1 py-2 transition-colors ${
                active ? 'text-amber-600' : 'text-gray-400 hover:text-gray-600'
              }`}
            >
              <Icon className="h-5 w-5" />
              <span className={`text-xs mt-1 ${active ? 'font-medium' : ''}`}>{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
